import { useState } from "react";
import Button from "@mui/material/Button";
import { Box, TextField } from "@mui/material";

import { LoadingButton } from "@mui/lab";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import api from "../hooks/apiClient";
const OrderMsgDialog = ({ ToggleOpen, open }) => {
  const [msgData, setMsgData] = useState({
    customer_name: "",
    phone: "",
    order_id: "",
    order_name: "",
    order_total: "",
  });
  const handleRegister = async () => {
    try {
      const res = await api.post("whatsapp/order/message", msgData);

      ToggleOpen();
    } catch (error) {
      console.error("Registration failed:", error);
    }
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={() => ToggleOpen()}
        aria-labelledby="edit-order-dialog-title"
        aria-describedby="edit-order-dialog-description"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle id="edit-order-dialog-title" sx={{ pb: 1 }}>
          Order Message
        </DialogTitle>

        <DialogContent sx={{ pt: 2 }}>
          <Box
            sx={{
              p: 2,
              mb: 2,
              borderRadius: 1,
              boxShadow: "0px 2px 4px rgba(0,0,0,0.1)",
              backgroundColor: "background.paper",
            }}
          >
            <TextField
              required
              fullWidth
              autoComplete="off"
              label="Customer Name"
              placeholder="Enter Customer name..."
              value={msgData.customer_name}
              onChange={(e) =>
                setMsgData((prev) => ({
                  ...prev,
                  customer_name: e.target.value,
                }))
              }
              sx={{ mb: 2 }}
            />
            <TextField
              required
              fullWidth
              autoComplete="off"
              label="Mobile"
              placeholder="Enter Mobile..."
              value={msgData.phone}
              onChange={(e) =>
                setMsgData((prev) => ({
                  ...prev,
                  phone: e.target.value,
                }))
              }
              sx={{ mb: 2 }}
            />
            <TextField
              required
              fullWidth
              autoComplete="off"
              label="Order ID"
              placeholder="Enter order id..."
              value={msgData.order_id}
              onChange={(e) =>
                setMsgData((prev) => ({
                  ...prev,
                  order_id: e.target.value,
                }))
              }
              sx={{ mb: 2 }}
            />
            <TextField
              required
              fullWidth
              autoComplete="off"
              label="Order Number"
              placeholder="Enter order num..."
              value={msgData.order_name}
              onChange={(e) =>
                setMsgData((prev) => ({
                  ...prev,
                  order_name: e.target.value,
                }))
              }
              sx={{ mb: 2 }}
            />

            <TextField
              required
              fullWidth
              autoComplete="off"
              label="Order Total"
              placeholder="order total..."
              value={msgData.order_total}
              onChange={(e) =>
                setMsgData((prev) => ({
                  ...prev,
                  order_total: e.target.value,
                }))
              }
              sx={{ mb: 3 }}
            />

            <LoadingButton
              variant="contained"
              loading={false}
              color="primary"
              fullWidth
              onClick={handleRegister}
              sx={{ py: 1 }}
            >
              Submit
            </LoadingButton>
          </Box>
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={() => ToggleOpen()} color="inherit">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default OrderMsgDialog;
